/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import NProgress from 'nprogress';
import Backbone from 'backbone';
import _ from 'lodash';

import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';
import { isAuthorized } from '@/util/RoleUtils';
import ErrorView from '@/views/ErrorView';

import OrderDashboardPage from '../pages/OrderDashboardPage';

export default async function ShowOrderHistoryPage() {
  NProgress.start();

  try {
    NavUtils.navigate('ext/order-history');
    if (EXTERNAL && !isAuthorized()) {
      showAuthError();
      return;
    } else if (!EXTERNAL) {
      showErrorView();
      return;
    }

    Scaffold.getRegion('content').show(
      new OrderDashboardPage({
        model: new Backbone.Model({
          returnLabel: 'Return to Dashboard',
          returnLink: '#ext/dashboard'
        })
      })
    );
  } catch(err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: _.isString(err.message) ? err.message : 'An Error Occurred',
          errorDetails: 'Something went wrong while loading the Order History page.'
        })
      })
    );
  } finally {
    NProgress.done();
  }
}

function showAuthError() {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: 'Not Authorized',
        errorDetails: 'You are not yet an authorized user. Please contact an administrator.'
      })
    })
  );
  NProgress.done();
}

function showErrorView() {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: 'Access Denied',
        errorDetails: 'Your account may not have permission to view the Customer Order History page.'
      })
    })
  );
  NProgress.done();
}